export enum AvailableOutletTypes {
  OUTLET = 'outlet',
  TPOUTLET = 'tpOutlet',
}
